var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{ref:"pbiContainer",staticClass:"pbi-container"},[(_vm.isLoading)?_c('span',[_vm._v("Fetching token...")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }